<div class="flex flex-col gap-2">
  @if (links.length) {
    <div class="flex flex-wrap gap-1.5">
      @for (link of links; track getLinkKey(link)) {
        <span
          class="inline-flex max-w-full items-center rounded-full bg-slate-100 text-sm font-medium text-slate-700"
          [class.opacity-70]="link.missing"
        >
          <button
            type="button"
            class="inline-flex min-w-0 items-center gap-1.5 rounded-full py-1 pl-2.5 text-left disabled:cursor-default"
            [ngClass]="{ 'pr-2.5': disabled, 'hover:text-orange-600': canOpen(link) }"
            [disabled]="!canOpen(link)"
            [title]="link.name"
            (click)="openLink.emit(link)"
          >
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none text-slate-400">{{
              icons[link.entity_type]
            }}</app-icon>
            <span class="truncate" [class.line-through]="link.missing">
              {{ link.name || ('crm_tasks.links.unavailable' | translate) }}
            </span>
            <span class="shrink-0 text-xs font-normal text-slate-400">{{ getLinkTypeKey(link) | translate }}</span>
          </button>
          @if (!disabled) {
            <button
              type="button"
              class="mx-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-slate-400 hover:bg-rose-50 hover:text-rose-600"
              [attr.aria-label]="'delete' | translate"
              (click)="remove(link)"
            >
              <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">close</app-icon>
            </button>
          }
        </span>
      }
    </div>
  } @else if (disabled) {
    <span class="text-sm text-slate-400">—</span>
  }

  <div #origin>
    @if (!disabled) {
      <div
        class="flex h-10 items-center rounded-lg border border-slate-200 bg-white text-sm transition focus-within:border-orange-400"
      >
        <span class="flex h-full w-9 shrink-0 items-center justify-center text-slate-400">
          <app-icon class="!h-5 !w-5 !text-[20px] !leading-5">search</app-icon>
        </span>
        <input
          type="text"
          class="h-full min-w-0 flex-1 border-0 bg-transparent pr-3 text-sm text-slate-800 outline-none placeholder:text-slate-400"
          autocomplete="off"
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="open"
          [attr.aria-controls]="listboxId"
          [attr.aria-activedescendant]="activeIndex >= 0 ? optionId(activeIndex) : null"
          [ngModel]="query"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onQueryChange($event)"
          (focus)="onFocus()"
          (keydown)="onKeydown($event)"
          [placeholder]="'crm_tasks.links.search_placeholder' | translate"
          [attr.aria-label]="'crm_tasks.links.search_placeholder' | translate"
        />
      </div>
    }
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (overlayOutsideClick)="onOutsideClick($event)"
  (detach)="open = false"
>
  <div
    class="crm-scroll max-h-72 overflow-y-auto rounded-lg border border-slate-200 bg-white py-1 shadow-lg"
    role="listbox"
    [id]="listboxId"
    [attr.aria-busy]="searching"
    [ngClass]="{ 'pointer-events-none opacity-60': searching }"
  >
    @if (searching && !freshResults.length) {
      <div class="flex h-12 items-center justify-center">
        <app-loader type="indeterminate" />
      </div>
    } @else {
      @for (target of freshResults; track getLinkKey(target); let index = $index) {
        <button
          type="button"
          role="option"
          class="flex w-full min-w-0 items-center gap-2 px-3 py-2 text-left transition"
          [id]="optionId(index)"
          [attr.aria-selected]="index === activeIndex"
          [ngClass]="index === activeIndex ? 'bg-slate-100' : 'hover:bg-slate-50'"
          (mousedown)="$event.preventDefault()"
          (click)="select(target)"
        >
          <span class="grid h-7 w-7 shrink-0 place-items-center rounded-md bg-slate-100 text-slate-500">
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">{{ icons[target.entity_type] }}</app-icon>
          </span>
          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm font-medium text-slate-900">{{ target.name }}</span>
            @if (target.subtitle) {
              <span class="block truncate text-xs text-slate-500">{{ target.subtitle }}</span>
            }
          </span>
          <span class="shrink-0 text-xs font-medium text-slate-400">{{ getLinkTypeKey(target) | translate }}</span>
        </button>
      } @empty {
        <div class="px-3 py-2 text-sm text-slate-500">{{ 'crm_tasks.links.nothing_found' | translate }}</div>
      }
    }
  </div>
</ng-template>
